import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from '../../../modules/react-forms/lib/index';
import Button from '../../../modules/ui-kit-react/lib/components/Button/index';
import EksHelmFields from '../../Providers/EksHelmFields';
import style from '../style.module.css';

class EksHelmForm extends Component {
  form = React.createRef();

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    eksHelmConfiguration: PropTypes.shape({
      id: PropTypes.string
    })
  };

  static defaultProps = {
    eksHelmConfiguration: null
  };

  render() {
    const { eksHelmConfiguration, onCancel, onSubmit } = this.props;

    return (
      <React.Fragment>
        <div className={style.content}>
          <Form ref={this.form} onSubmit={onSubmit}>
            <EksHelmFields
              eksHelmConfiguration={eksHelmConfiguration}
            />
          </Form>
        </div>
        <div className={style.foot}>
          <Button
            raised
            appearance="primary"
            onClick={() => this.form.current.submit()}
          >
            Update
          </Button>
          <Button appearance="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default EksHelmForm;
